import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AccordionText from './AccordionText.vue'

type Props = {
  text: string
  textOpen?: string
  size?: 'small' | 'medium' | 'large' | 'extrasmall'
  active?: boolean
}

type Emits = {
  (e: 'onClicked'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionExpander',
  props: {
    text: {},
    textOpen: { default: undefined },
    size: { default: 'medium' },
    active: { type: Boolean, default: false }
  },
  emits: ["onClicked"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit



function onClicked() {
  emit('onClicked')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionText, {
    accordionText: _ctx.active ? _ctx.textOpen ?? _ctx.text : _ctx.text,
    size: _ctx.size,
    active: _ctx.active,
    onOnClicked: onClicked
  }, null, 8, ["accordionText", "size", "active"]))
}
}

})